import type { CardHooks } from "./registry";
import { makeBuff } from "../playtestEngine";

/**
 * Follow Up — Maneuver utility.
 * Effect: your next attack gains the Chain keyword.
 *
 * Implementation: queue a `gain-chain` buff with trigger `next-attack`.
 * The engine's firePendingBuffs fires it when the player next plays an
 * attack; keywordGrantsFromFired then folds "Chain" into the combat slot's
 * grantedKeywords, which resolveAttackPlay reads (see line 811 in
 * playtestEngine.ts: `(snap.grantedKeywords ?? []).some(... === "chain")`).
 */
export const followUp: CardHooks = {
  onUtilityPlay: (ctx) => ({
    queueSelfBuff: makeBuff(
      "Follow Up",
      "next-attack",
      { kind: "gain-chain" },
      ctx.game.round,
    ),
    log: ["Follow Up — next attack gains Chain"],
  }),
};
